// Shared by the browser's JSON-LD paths and the Node document renderer.
// Keep this CommonJS so the server can load the same implementation without transpilation.
const requiredFields = {
  Restaurant: ['name', 'url'],
  FoodEstablishment: ['name', 'url'],
  GeoCoordinates: ['latitude', 'longitude'],
  AggregateRating: ['ratingValue', 'ratingCount'],
  EntryPoint: ['urlTemplate'],
  OrderAction: ['target'],
  WebPage: ['@id'],
  Menu: ['name'],
  MenuSection: ['name'],
  MenuItem: ['name'],
  ListItem: ['item', 'position'],
};

const cleanRestaurantSchema = (value) => {
  if (value == null) return undefined;
  if (typeof value === 'string') return value.trim() ? value : undefined;
  if (typeof value === 'number')
    return Number.isFinite(value) ? value : undefined;
  if (typeof value === 'boolean') return value;
  if (Array.isArray(value)) {
    const entries = value
      .map(cleanRestaurantSchema)
      .filter((entry) => entry !== undefined);
    return entries.length ? entries : undefined;
  }
  if (
    typeof value !== 'object' ||
    Object.getPrototypeOf(value) !== Object.prototype
  ) {
    return undefined;
  }

  const result = {};
  Object.entries(value).forEach(([key, entry]) => {
    const cleaned = cleanRestaurantSchema(entry);
    if (cleaned !== undefined) result[key] = cleaned;
  });

  const type = result['@type'];
  if (
    type === 'PostalAddress' &&
    !['streetAddress', 'addressLocality', 'addressRegion', 'postalCode'].some(
      (key) => result[key] !== undefined
    )
  )
    return undefined;
  if (
    type === 'Offer' &&
    result.name === undefined &&
    result.price === undefined
  ) {
    return undefined;
  }
  if (requiredFields[type]?.some((key) => result[key] === undefined))
    return undefined;
  if (
    !Object.keys(result).some((key) => key !== '@context' && key !== '@type')
  ) {
    return undefined;
  }
  return result;
};

module.exports = cleanRestaurantSchema;
